module.exports = __webpack_public_path__ + "img/background.034db74e.png";